import React from 'react';
import Dave from '../components/imgs/download001.jpg';
import Vick from '../components/imgs/prof_pic.jpg'



export default function About (props) {
  let staff = []
class Staff{
  constructor(name, img){
    this.name = name;
    this.img = img;
  }}
const dave = new Staff('Dave Brown', '../components/imgs/download001.jpg')
const vick = new Staff('Vicktor Moberg', '../components/imgs/prof_pic.jpg')
staff.push(dave, vick)
  return(
    <div >
      <h2>About Us</h2>
      <article>
        <h3>Our Mission</h3>
        <p>As the venerable Archbishop Fulton J. Sheen once said, “The worst thing in the world is not sin, it is denying that we are sinners.  Sinners who deny that there is sin, deny thereby the remedy of sin, and thus cut themselves off forever from him who came to redeem.”  After all, our Lord and savior Jesus Christ made explicitly clear that: “Whoever wishes to come after me must deny himself, take up his cross, and follow me.  For whoever wishes to save his life will lose it, but whoever loses his life for my sake will find it.  What profit would there be for one to gain the whole world and forfeit his life?  Or what can one give in exchange for his life?  For the Son of Man will come with his angels in his Father’s glory, and then he will repay everyone according to his conduct.”  Matthew 16: 24-27.</p>

        <p>This is most certainly a dilemma that many of us wish to ignore.  After all, many of us are burdened with extremely large and heavy crosses; crosses that seem unfair and unbearable.  As humans, we regularly experience intense temptations and desires, each promising success, pleasure, wealth, happiness, comfort, security, etc.  Moreover, some of us are predisposed to seemingly insurmountable addictions or compulsions.</p>

        <p>Even worse, the world urges us to deny the existence of objective truth and give in to the weight of our crosses rather than fighting to carry them.  Consider the relativist slogans of this world: “It’s okay, because God made me this way”; or “God loves me just the way that I am”; or “What’s true for you isn’t necessarily what’s true for me”; or God just wants me to be happy”.  While it’s true that God loves each and every one of us unconditionally, God “wills everyone to be saved and to come to the knowledge of truth.”  2 Timothy 2:4.</p>

        <p>With this in mind, we have to be honest with ourselves – we all have a cross (or multiple crosses) to carry.  Moreover, the odds of overcoming our trials alone are slim to none.  Whether we realize it or not, we need the prayers of our brothers and sisters in Christ to win this spiritual battle.  We need someone to help us carry our crosses!</p>

        <p>Enter, Simon of Cyrene.</p> 

        <p>Remember, even Jesus needed help carrying his physical cross.  The Bible tells us that “they compelled a passer-by coming from the country, Simon of Cyrene (the father of Alexander and Rufus), to carry His cross.”  Mark 15:21.</p>

        <p>Just like Simon of Cyrene helped Jesus carry his cross, our community is here to help you carry your crosses!  We’ve got your back and we’re here to give you the spiritual lift that you need to be victorious in your battle!</p>
        </article>
      <article >
        <h3> Meet Us</h3>
        <div className="headshots">
        <article >
        <img src={Dave} className="headShot" id="dave" alt="Dave" />
        <p>Dave Brown</p>
        </article>
        <article>
          <img src={Vick} className="headShot" id="vick" alt= "Vick" />
          <p>Vick Moberg</p>
        </article>
        </div>
      </article>
    </div>

  )
}